import { createFileRoute } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';

import { PlaceholderPage } from '@/components/layout/PlaceholderPage';

export const Route = createFileRoute('/_app/users')({
	component: UsersRoute,
});

function UsersRoute() {
	const { t } = useTranslation();
	return (
		<PlaceholderPage
			title={t('nav.users')}
			description={t('placeholder.users.description')}
			scope={t('placeholder.users.scope')}
		/>
	);
}
